import React, { Component } from 'react'
import { Button } from '@material-ui/core'
import { Card } from 'react-bootstrap'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_CONTACTO } from '../../../../config/forms'
import CamposContacto from './CamposContacto'
import isEmail from 'validator/lib/isEmail'
import { isEmpty } from 'lodash'

class DialogoContacto extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isValidEmail: false,
      isValidNombre: false,
      valueEmail: null,
      valueNombre: null
    }
  }

  render () {
    const {
      handleClose,
      onSubmitContacto
    } = this.props
    const {
      isValidEmail,
      isValidNombre
    } = this.state

    const handleChangeEmail = event => {
      const val = event.target.value
      if (isEmail(val)) {
        this.setState({ isValidEmail: true })
      } else {
        this.setState({ isValidEmail: false })
      }
    }

    const handleChangeNombre = event => {
      const val = event.target.value
      if (isEmpty(val)) {
        this.setState({ isValidNombre: false })
      } else {
        this.setState({ isValidNombre: true })
      }
    }

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Nuevo contacto</Card.Text>
          </Card.Header>
          <Card.Body>
            <CamposContacto
              handleChangeEmail={handleChangeEmail}
              handleChangeNombre={handleChangeNombre}
            />
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              style={{ margin: '2%' }}
              onClick={handleClose}
              size='medium'
              variant='contained'
              color='primary'
            >Cancelar</Button>
            {(isValidEmail && isValidNombre)
              ? <Button
                style={{ margin: '2%' }}
                size='medium'
                variant='contained'
                color='primary'
                onClick={onSubmitContacto}
              >Guardar</Button>
              : <Button
                style={{ margin: '2%' }}
                size='medium'
                variant='contained'
                color='primary'
                disabled
              >Guardar</Button>
            }
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({

})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(reduxForm({
  form: FORM_CONTACTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: true
})(DialogoContacto))
